import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

export default function LegalLayout({ title, updated, intro, sections }) {
  return (
    <div className="bg-white pb-24 pt-28 lg:pt-36">
      <div className="container-x">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-ink-3 transition hover:text-ink">
          <ArrowLeft className="size-4" aria-hidden="true" /> Back to home
        </Link>
        <header className="mt-8 max-w-3xl border-b border-line pb-10">
          <p className="eyebrow">Legal</p>
          <h1 className="mt-4 font-display text-5xl font-semibold tracking-[-0.04em] sm:text-6xl">{title}</h1>
          <p className="mt-4 font-mono text-xs uppercase tracking-[0.14em] text-ink-3">Last updated: {updated}</p>
          {intro && <p className="mt-6 text-lg leading-relaxed text-ink-3">{intro}</p>}
        </header>

        <div className="mt-12 grid gap-12 lg:grid-cols-[230px_1fr] lg:gap-16">
          <nav aria-label="On this page" className="hidden lg:block">
            <ol className="sticky top-28 space-y-2.5 border-l border-line pl-4 text-sm">
              {sections.map((s, i) => (
                <li key={s.title}>
                  <a href={`#${slug(s.title)}`} className="text-ink-3 transition hover:text-ink">
                    {i + 1}. {s.title}
                  </a>
                </li>
              ))}
            </ol>
          </nav>

          <article className="min-w-0 max-w-3xl space-y-12 break-words">
            {sections.map((s, i) => (
              <section key={s.title} id={slug(s.title)} className="scroll-mt-28">
                <h2 className="font-display text-2xl font-semibold tracking-[-0.02em]">
                  <span className="mr-2 text-ink-3">{i + 1}.</span>
                  {s.title}
                </h2>
                <div className="mt-4 space-y-4 leading-relaxed text-ink-2">
                  {s.body.map((b, j) =>
                    Array.isArray(b) ? (
                      <ul key={j} className="space-y-2.5">
                        {b.map((item) => (
                          <li key={item} className="flex gap-3">
                            <span className="mt-[0.6rem] size-1.5 shrink-0 rounded-full bg-gradient-to-r from-fusion-blue to-fusion-teal" />
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p key={j}>{b}</p>
                    )
                  )}
                </div>
              </section>
            ))}
          </article>
        </div>
      </div>
    </div>
  );
}
